export const socialsData = {
    github: 'https://github.com/SavvyEngineer',
    linkedIn: 'https://www.linkedin.com/in/khashayar-kazemi/',
    mail: 'mailto:khashayar.kazemi.info@gmail.com',
    phone: 'tel:+436641476069',
}
